import { Component, OnInit } from '@angular/core';
import {CookieService} from 'angular2-cookie/core';
import {Router} from "@angular/router";

import { shuttleService } from '../data/shuttle.service';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],

})
export class LoginComponent implements OnInit {
     app_active:boolean = false;
     shuttle_id : number = 0;
     //shuttle:shuttle;
     constructor(private _cookieService:CookieService,private router: Router){//,private _data_service: data_service){
          console.log('app constructing');
          //console.log(shuttle);
          this.set_app_shuttle(0);

          var cookie_shuttle = this.get_cookie('app_shuttle');
          console.log('cookie_shuttle ' + cookie_shuttle);
          if(cookie_shuttle){
               this.set_app_shuttle(cookie_shuttle);
          }


     }

     ngOnInit(){

     }

     set_app_shuttle(shuttle_id){
          console.log(shuttle_id);
          if(this.validate_shuttle_id(shuttle_id)){
               this.shuttle_id = shuttle_id;
               //this.shuttle.id = shuttle_id;
               this.save_cookie('app_shuttle',shuttle_id);

               //this._data_service.get_a_shuttle();
          }
     }

     activate_app(){
          console.log('activate app');
          this.app_active = true;

     }

     app_login(dn,pass){
          console.log(dn);
          dn = 366;
          pass = '1234';
          console.log('logging in');
          //validate user and password
          this.save_cookie('app_driver',dn);
          this.router.navigate(['/shuttle/start']);

     }

     validate_shuttle_id(shuttle_id){
          if(shuttle_id >=0){
               ///+++check if shuttle is valid
               return true;
          } else {
               return false;
          }
     }


     //COOKIE FUNCTIONS
     get_cookie(key: string){
          return this._cookieService.get(key);
     }

     save_cookie(key,value){
          this._cookieService.put(key, value);
     }

}
